import getCampaignCharacters from './getCampaignCharacters.js';

const blank_roll_save = ['blank', 'Roll New', 'Save Local Backup'];
const separator = '---';

const greyhawk_characters = [
                'Sample Character', separator,
                'Grok-Nar', 'Sylonnus Transvexus',  
                'Charles', 'Paul',
                'Martin', 
                'Yarg Smashskull', 'Lanora Snugglebottom'
                
                // 'Eli', 'Trunk', 'Trea', 'Zum', 'Fonk', 'Gerthmig', 'Tonk', 'Davbin', 
                // 'Rygar', separator,
                // 'Sylonnus', 'Grok-Nar', separator,
                
            ];

async function getUniqueCharacterNames(array, username) {
    // Create Sets to store unique character names
    const uniqueNamesUser = new Set();
    const uniqueNamesOther = new Set();
    
    // First, collect names for the specified user
    array.forEach(item => {
      if (item.userName === username) {
        uniqueNamesUser.add(item.characterName);
      }
    });
    
    // Then, collect names for other users, excluding those in uniqueNamesUser
    array.forEach(item => {
      if (item.userName !== username && !uniqueNamesUser.has(item.characterName)) {
        uniqueNamesOther.add(item.characterName);
      }
    });

    // filter out special characters from uniqueNamesOther
    // any character name that starts with 'test' is a special character
    // any character name that starts with 'DM' is a private character
    // also any specifically listed in the array dontShowCharacters

    let dontShowCharacters = ['Sample Character','Sylonnus Transvexus', 'Grok-Nar', 'Rygar', 'Eli', 'Trunk', 'Trea', 'Zum', 'Fonk', 'Gerthmig', 'Tonk', 'Davbin'];
    let filteredUniqueNamesOther = Array.from(uniqueNamesOther).filter(name => !name.startsWith('test'));
    
    filteredUniqueNamesOther = filteredUniqueNamesOther.filter(name => !name.startsWith('DM-'));
    filteredUniqueNamesOther = filteredUniqueNamesOther.filter(name => !dontShowCharacters.includes(name));

    // Convert Sets to arrays and return as object
    return {
      uniqueNamesUser: Array.from(uniqueNamesUser),
      uniqueNamesOther: Array.from(filteredUniqueNamesOther)
    };
  }

export async function getCharacterList(userData) {
  // get the list of characters for this user

  let charactersInCampaign = [];
  let charactersToDisplay = []; 

  if (userData?.currentCampaign) {
    charactersInCampaign = await getCampaignCharacters(userData.currentCampaign);
    charactersInCampaign = await getUniqueCharacterNames(charactersInCampaign, userData.uniqueUser);
    charactersToDisplay = [...charactersInCampaign.uniqueNamesUser, separator, ...charactersInCampaign.uniqueNamesOther];
  }
  // default value if no campaign is selected
  else { 
    charactersToDisplay = greyhawk_characters;
  }

  // set the character list to the characters in the campaign
  if (charactersToDisplay.length === 0) return [...blank_roll_save]
  return [...charactersToDisplay, separator, ...blank_roll_save];
}

export default getCharacterList